import { XMarkIcon } from '@heroicons/react/24/outline';
import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import AstroImage from '@/components/ui/custom/AstroImage';
import { Button } from '@/components/ui/daisy/button';

type MobileDrawerPanelProps = PropsWithChildren<
  Pick<ComponentPropsWithoutRef<'div'>, 'aria-label' | 'className'> & {
    closeLabel: string;
    onClose(): void;
  }
>;

export default function MobileDrawerPanel({
  closeLabel,
  onClose,
  className,
  children,
  ...props
}: MobileDrawerPanelProps) {
  return (
    <div
      role="dialog"
      className={twMerge(
        'flex min-h-full w-82.5 max-w-full flex-col gap-5 bg-base-100 px-4 pt-4 pb-10',
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-between">
        <AstroImage
          src="/images/cna-logo.svg"
          alt="CNA"
          className="h-6 w-16 shrink-0"
        />
        <Button aria-label={closeLabel} onClick={onClose}>
          <XMarkIcon className="size-3.5" />
        </Button>
      </div>
      {children}
    </div>
  );
}
